<template>
  <div class="main-blur-spinner" v-if="visible_spinner">
      <div class="loading-text-under">{{loadingText}}</div>
      <div>
        <svg class="dot-spin" viewBox="0 0 50 50">
          <circle
            class="path"
            cx="25"
            cy="25"
            r="20"
            fill="none"
            stroke-width="5"
          ></circle>
        </svg>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    loadingText(){
      return this.$store.state.main_loading_spinner_text;
    },
    visible_spinner() {
       return  this.$store.state.main_loading_spinner;
    },
  },
};
</script>
